// Language switcher
class languageSwitcher extends HTMLElement {
  constructor() {
    super();

    this.languageSwitcherTrigger = this.querySelector('[data-language-switcher-trigger]');
    this.languageSwitcherContent = this.querySelector('[data-language-switcher-content]');
    this.languageSwitcherList = this.querySelector('.language-switcher__list');
    this.orbeCountryList = document.getElementById('orbeCountryList');
    this.orbeElement = document.querySelector('.orbe-custom-button-block');
    this.languageSwitcher = document.querySelector('language-switcher');

    this.init();
  }

  init() {
    // Copy elements from orbeCountryList to language-switcher__list
    //this.copyElementsFromOrbeCountryList();

    // Add listeners to language-switcher__list for changes
    //this.addLanguageSwitcherListListeners();

    if (this.orbeElement) {
      //this.languageSwitcher.innerHTML = this.orbeElement.innerHTML;
    } else {
      // Catch click on trigger
      this.languageSwitcherTrigger.addEventListener('click', () => {
        // Rotate icon
        var triggerIcon = this.languageSwitcherTrigger.querySelector(
          '.language-switcher__list-item-icon .icon'
        );
        if (triggerIcon.classList.contains('rotate-180')) {
          triggerIcon.classList.remove('rotate-180');
        } else {
          triggerIcon.classList.add('rotate-180');
        }
        // Toggle visible class exists
        if (this.languageSwitcherContent.classList.contains('hidden')) {
          this.languageSwitcherContent.classList.remove('hidden');
        } else {
          this.languageSwitcherContent.classList.add('hidden');
        }
      });
    }
  }

  copyElementsFromOrbeCountryList() {
    if (this.orbeCountryList && this.languageSwitcherList) {
      // Clear existing content
      this.languageSwitcherList.innerHTML = '';

      // Clone all child elements from orbeCountryList
      const elements = Array.from(this.orbeCountryList.children);
      elements.forEach((element) => {
        const clonedElement = element.cloneNode(true);
        this.languageSwitcherList.appendChild(clonedElement);
      });
    }
  }

  addLanguageSwitcherListListeners() {
    if (this.languageSwitcherList) {
      // Listen for clicks on language switcher list items
      this.languageSwitcherList.querySelectorAll('li').forEach((li) => {
        li.addEventListener('click', (event) => {
          const clickedElement = event.target.closest('a');
          if (clickedElement) {
            // Find corresponding element in orbeCountryList
            const orbeElements = Array.from(this.orbeCountryList.children);
            const languageElements = Array.from(this.languageSwitcherList.children);

            const clickedIndex = languageElements.findIndex(
              (el) => el.contains(clickedElement) || el === clickedElement
            );

            if (clickedIndex !== -1 && orbeElements[clickedIndex]) {
              // Trigger click on corresponding orbeCountryList element
              document.getElementById('md-form__select__country').dataset.value =
                clickedElement.dataset.value;
              document.getElementById('md-btn__form__onSubmit').click();
            }
          }
        });
      });
    }
  }
}

if (!customElements.get('language-switcher')) {
  customElements.define('language-switcher', languageSwitcher);
}
